import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AiOutlineRight } from 'react-icons/ai';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { HEALTH_INSURANCE, TURNS_DATE_PATH, TURNS_PATH } from '../../routes/path';
import './index.scss';
import { saveDoctor } from '../../redux/actions/doctorActions';
import { savehealthInsurance } from '../../redux/actions/healthInsuranceActions';

const Card = ({ info, type }) => {
  const [isHovered, setIsHovered] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { nombre: name } = info;

  const handleHover = () => {
    setIsHovered(!isHovered);
  };

  const typeInfo = {
    health: {
      function: () => savehealthInsurance(info),
      navigate: `${TURNS_PATH}${TURNS_DATE_PATH}`,
    },
    doctor: {
      function: () => saveDoctor(info),
      navigate: `${TURNS_PATH}${HEALTH_INSURANCE}`,
    }
  };

  const option = typeInfo[type];
  return (
    <div
      onClick={() => {
        dispatch(option.function());
        navigate(option.navigate);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          dispatch(option.function());
          navigate(option.navigate);
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div
        className={`container-select ${type === 'health' ? 'health' : ''} ${type === 'doctor' ? 'space' : 'notSpace'} ${isHovered ? 'container-select--hovered' : ''}`}
        defaultValue="placeholder"
        onMouseEnter={handleHover}
        onMouseLeave={handleHover}
      >
        {type === 'doctor' ? (
          <div className="container-listDoctor">
            <img className="img" src={`${process.env.REACT_APP_BACKEND_URL}${info.foto_sm_url}`} alt={`Dr. ${name} ${info.apellido}`} />
            <div className="container-doctorDescription">
              <p className="text-doctor">
                {`Dr. ${name} ${info.apellido}`}
              </p>
              <p className="description-doctor">
                {info?.especialidad}
              </p>
            </div>
          </div>
        )
          : (
            <>
              <p>
                {name}
              </p>
              <div className="option-red">
                <AiOutlineRight />
              </div>

            </>
          )}
      </div>

    </div>
  );
};

Card.propTypes = {
  info: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string,
    foto_sm_url: PropTypes.string,
    especialidad: PropTypes.string,
    apellido: PropTypes.string,
  }).isRequired,
  type: PropTypes.string.isRequired
};

export default Card;
